module.exports = __webpack_public_path__ + "static/media/hanukiah.f460325c.svg";